module.exports = __webpack_public_path__ + "static/media/5.96875f2a.png";